import styled, { keyframes } from "styled-components";
import Logo from "@assets/icons/health-nz-logo.svg";
import ACALogo from "@assets/icons/aca-logo.png";
import RNZCGPLogoImg from "@assets/icons/rnzcgpLogo.png";
import MOHLogo from "@assets/icons/moh_logo.svg";
import ASIDLogo from "@assets/icons/asid-logo.png";

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const EndorsementSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 1320px;
  min-width: 0;
  overflow: hidden;
  position: relative;
  margin: 16px auto 0;
  padding: 0 16px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 0 100px;
    margin-top: -60px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  color: #334a74;
  margin: 0;
  text-align: left;
`;

const MarqueeContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 50px;
    height: 100%;
    z-index: 2;
    pointer-events: none;

    @media (min-width: 768px) {
      width: 100px;
    }

    @media (min-width: 1024px) {
      display: none;
    }
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #f3f9f9, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #f3f9f9, transparent);
  }
`;

const MarqueeContent = styled.div`
  display: flex;
  gap: 48px;
  align-items: center;
  animation: ${scroll} 30s linear infinite;
  will-change: transform;

  &:hover {
    animation-play-state: paused;
  }

  @media (min-width: 1024px) {
    animation: none;
    justify-content: flex-start;
  }
`;

const LogoGroup = styled.div`
  display: flex;
  gap: 48px;
  align-items: center;
  flex-shrink: 0;

  &:nth-child(2),
  &:nth-child(3) {
    @media (min-width: 1024px) {
      display: none;
    }
  }
`;

const LogoWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  
  svg {
    max-width: 140px;
    max-height: 80px;
    width: 100%;
    height: auto;
    display: block;
  }
`;

const LogoImage = styled.img`
  max-width: 140px;
  max-height: 80px;
  width: 100%;
  height: auto;
  display: block;
`;

const EndorsingOrganisations = () => {
  // Define logos array for easy duplication
  const logos = [
    { id: 'health-nz', type: 'svg', component: <Logo /> },
    { id: 'aca', type: 'img', src: ACALogo, alt: 'ACA Logo'},
    { id: 'rnzcgp', type: 'img', src: RNZCGPLogoImg, alt: 'RNZCGP Logo' },
    { id: 'moh', type: 'svg', component: <MOHLogo /> },
    { id: 'asid', type: 'img', src: ASIDLogo, alt: 'ASID Logo'},
    // Add more logos here as they become available
  ];

  return (
    <EndorsementSection>
      <SectionTitle>Endorsing organisations</SectionTitle>
      <MarqueeContainer>
        <MarqueeContent>
          {/* First set of logos */}
          <LogoGroup>
            {logos.map((logo) => (
              <LogoWrapper key={`${logo.id}-1`}>
                {logo.type === 'svg' ? logo.component : <LogoImage src={logo.src} alt={logo.alt} />}
              </LogoWrapper>
            ))}
          </LogoGroup>

          {/* Duplicate set for seamless loop */}
          <LogoGroup>
            {logos.map((logo) => (
              <LogoWrapper key={`${logo.id}-2`}>
                {logo.type === 'svg' ? logo.component : <LogoImage src={logo.src} alt={logo.alt} />}
              </LogoWrapper>
            ))}
          </LogoGroup>

          {/* Third duplicate for very smooth loop */}
          <LogoGroup>
            {logos.map((logo) => (
              <LogoWrapper key={`${logo.id}-3`}>
                {logo.type === 'svg' ? logo.component : <LogoImage src={logo.src} alt={logo.alt} />}
              </LogoWrapper>
            ))}
          </LogoGroup>
        </MarqueeContent>
      </MarqueeContainer>
    </EndorsementSection>
  );
};

export default EndorsingOrganisations;